module.exports = __webpack_public_path__ + "static/media/send-tasks-explanation.e43ef05f.svg";